import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import EthereumWalletHero from "./EthereumWalletHero";
import Specializes from "./Specializes";
import MajorFunctionalities from "./MajorFunctionalities";
import FeaturesWallet from "./FeaturesWallet";
import WhyChoose from "../NFT Wallet/WhyChoose";

function EthereumWallet() {
  return (
    <div>
      <Header />
      <EthereumWalletHero />
      <Specializes />
      <MajorFunctionalities />
      <FeaturesWallet />
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default EthereumWallet;
